module.exports = __webpack_public_path__ + "img/menu-movil-icon.2fe7f4df.svg";